import { CommercialOperationLabel } from '..';

export class SupplierCommercialOperationLabel extends CommercialOperationLabel {
    constructor() {
        super();
    }
}

